import { useContext } from "react";
import { AutoTableContext } from "./auto-table-provider.contants";

/**
 * Hook to access the AutoTableProvider context.
 * @returns Context of the AutoTableProvider.
 */
export const useAutoTableProvider = () => {
    const context = useContext(AutoTableContext);
    if (!context) {
        throw new Error("useAutoTableProvider must be used within an AutoTableProvider");
    }
    return context;
};
